window.PopupManager = {
    popups: {},
    currentOpenId: null,

    register: function (id, element, options = {}) {
        let originalScale = { x: 1, y: 1, z: 1 };
        const elScale = element.getAttribute('scale');
        
        if (elScale) {
            if (typeof elScale === 'object') {
                if (elScale.x !== 0 || elScale.y !== 0 || elScale.z !== 0) {
                    originalScale = { x: elScale.x, y: elScale.y, z: elScale.z };
                }
            } else if (typeof elScale === 'string') {
                const parts = elScale.trim().split(/\s+/).map(Number);
                if (parts.length === 3 && (parts[0] !== 0 || parts[1] !== 0 || parts[2] !== 0)) {
                    originalScale = { x: parts[0], y: parts[1], z: parts[2] };
                }
            }
        }
        
        this.popups[id] = {
            element: element,
            options: options,
            originalScale: originalScale
        };

        element.setAttribute('visible', false);
        element.setAttribute('scale', '0 0 0');        
    },

    open: function (id) {
        if (this.currentOpenId === id) {
            return;
        }
        if (this.currentOpenId) {
            this.close(this.currentOpenId);
        }

        const popup = this.popups[id];
        if (popup) {
            if (popup.element) {
                const s = popup.originalScale || { x: 1, y: 1, z: 1 };
                popup.element.setAttribute('scale', `${s.x} ${s.y} ${s.z}`);
                popup.element.setAttribute('visible', true);
                
                this.currentOpenId = id;
                
                const component = popup.element.components[id] || popup.element.components['info-popup'] || popup.element.components['configure-control'] || popup.element.components['sectors-control'] || popup.element.components['main-settings'] || popup.element.components['right-configure-popup'];

                if (component && typeof component.open === 'function') {
                    component.open();
                }

                if (popup.options.onOpen && typeof popup.options.onOpen === 'function') {
                    popup.options.onOpen();
                }
            }
        } else {
            console.warn(`[PopupManager] Popup not found: ${id}`);
        }
    },

    close: function (id) {
        if (this.currentOpenId === id) {
            this.currentOpenId = null;
        }

        const popup = this.popups[id];
        if (popup) {
            if (popup.element) {
                popup.element.setAttribute('visible', false);
                popup.element.setAttribute('scale', '0 0 0');
                
                if (popup.element.components) {
                     const component = popup.element.components[id] || popup.element.components['info-popup'] || popup.element.components['configure-control'] || popup.element.components['sectors-control'] || popup.element.components['main-settings'] || popup.element.components['right-configure-popup'];
                     
                     if (component && typeof component.close === 'function') {
                         component.close();
                     }
                }

                if (popup.options.onClose && typeof popup.options.onClose === 'function') {
                    popup.options.onClose();
                }
            }
        }
    },

    closeAll: function () {
        Object.keys(this.popups).forEach(id => {
            this.close(id);
        });
        this.currentOpenId = null;
    },
    
    isOpen: function(id) {
        return this.currentOpenId === id;
    },

    toggle: function (id) {
        if (this.currentOpenId === id) {
            this.close(id);
        } else {
            this.open(id);
        }
    }
};
